export interface VideoSearchResult {
  url: string;
  description: string;
  title: string;
}

export interface VideoSearch {
  query: string;
  results: VideoSearchResult[];
}

export interface VideoSearchResultsPayload {
  video_searches: VideoSearch[];
  timestamp: number;
}

export interface VideoSearchResultsMessage {
  type: 'video_search_results';
  payload: VideoSearchResultsPayload;
}

export interface VideoSearchState {
  searchResults: VideoSearchResult[];
  isLinkVisible: boolean;
}

export const initialVideoSearchState: VideoSearchState = {
  searchResults: [],
  isLinkVisible: false
};
